import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { environment } from 'environments/environment';
import { Logger } from './../../core/logger.service';
import * as Models from 'app/core/models';
import { TranslateService } from '@ngx-translate/core';
import { LookupService } from '../../core/lookup/lookup.service';

const log = new Logger('App');
@Component({
    selector: 'app-news-feed',
    templateUrl: './newsFeed.component.html',
    styleUrls: ['./newsFeed.component.scss']
})

export class NewsFeedComponent implements OnInit {



    version: string = environment.version;
    error: any = null;
    isLoading = false;
    newsFeedMessages: Array<Models.NewsFeedMessage>;

    constructor(private lookupService: LookupService,
        private translateService: TranslateService) {
    }

    ngOnInit(): void {
        this.isLoading = true;
        this.lookupService.getNewsFeedMessages()
            .finally(() => {
                this.isLoading = false;
            })
            .subscribe((newsFeedMessages: Array<Models.NewsFeedMessage>) => {
                this.error = null;
                this.newsFeedMessages = newsFeedMessages;
            }, error => {
                this.error = error;
            });
    }

    //   login() {
    //     this.isLoading = true;
    //     this.lookupService.login(this.loginForm.value)
    //       .finally(() => {
    //         if (!this.error) {
    //         } else {
    //           this.isLoading = false;
    //         }
    //       })
    //       .subscribe(credentials => {
    //         this.error = null;

    //       }, error => {
    //         this.error = error;
    //       });
    //   }


    get errorMessage(): string {
        if (this.error) {
            const errorBody = this.error._body ? JSON.parse(this.error._body) : null;
            if (errorBody && errorBody.error) {
                return errorBody.error;
            }
        }
        this.translateService.get('AUTH.LOGIN.GENERAL_ERROR').subscribe((translatedErrMsg: string) => {
            return translatedErrMsg
        });
    }

}





// WEBPACK FOOTER //
// C:/ProactiView/ProactiView-Client/src/app/home/newsFeed/newsFeed.component.ts